import { SupabaseMentor } from "@vincer/types";

import { supabase } from "./supabase";

const AUTH_HEADER = import.meta.env.VITE_DYTE_AUTH_HEADER;
console.log("Auth header", AUTH_HEADER);

const config = {
  title: "string",
  preferred_region: "us-east-1",
  record_on_start: true,
  live_stream_on_start: false,
  recording_config: {
    max_seconds: 60 * 60 * 24, // 24 hours
    file_name_prefix: "string",
    video_config: {
      codec: "H264",
      width: 1280,
      height: 720,
      watermark: {
        url: "https://example.com",
        size: {
          width: 1,
          height: 1,
        },
        position: "left top",
      },
      export_file: true,
    },
    audio_config: {
      codec: "AAC",
      channel: "stereo",
      export_file: true,
    },
  },
  persist_chat: false,
  summarize_on_end: false,
};

export async function createMeeting(meetingName: string) {
  const url = "https://api.dyte.io/v2/meetings";

  config.title = meetingName;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AUTH_HEADER,
    },
    body: JSON.stringify(config),
  };

  try {
    const response = await fetch(url, options as any);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return { status: "error", message: error };
  }
}

export async function addParticipant(
  meetingId: string,
  participantId: string,
  participantName: string,
  preset: string
) {
  console.log("Adding participant to meeting", meetingId, participantId);
  const url = `https://api.dyte.io/v2/meetings/${meetingId}/participants`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AUTH_HEADER,
    },
    body: JSON.stringify({
      name: participantName,
      preset_name: preset,
      custom_participant_id: participantId,
    }),
  };

  try {
    const response = await fetch(url, options as any);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return { status: "error", message: error };
  }
}

export async function startMeetingNow(
  // TODO: Fix this
  mentorObject: SupabaseMentor,
  menteeObject: any,
  duration: number = 60
) {
  try {
    console.log("Starting meeting creation process...", {
      mentorUuid: mentorObject.uuid,
      menteeUuid: menteeObject.uuid,
      duration,
    });

    const menteeName = menteeObject.name;
    const mentorName = mentorObject.user.name;

    const dyteMeeting = await createMeeting(
      `${menteeName}'s session with ${mentorName}`
    );
    console.log("Dyte meeting response:", dyteMeeting);

    if (dyteMeeting.status === "error") {
      console.error("Error creating dyte meeting:", dyteMeeting.message);
      throw new Error("Error creating dyte meeting");
    }

    console.log("Adding mentor participant to Dyte meeting...");
    const mentorParticipant = await addParticipant(
      dyteMeeting.data.id,
      mentorObject.uuid,
      mentorName,
      "group_call_host"
    );
    console.log("Mentor participant added:", mentorParticipant);

    console.log("Adding mentee participant to Dyte meeting...");
    const menteeParticipant = await addParticipant(
      dyteMeeting.data.id,
      menteeObject.uuid,
      menteeName,
      "group_call_participant"
    );
    console.log("Mentee participant added:", menteeParticipant);

    const menteeAuthToken = menteeParticipant.data.token;
    const mentorAuthToken = mentorParticipant.data.token;

    // Generate a UUID for the meeting
    const meetingUuid = dyteMeeting.data.id;
    console.log("Generated meeting UUID:", meetingUuid);

    console.log("Creating meeting record in Supabase...");
    const { data, error } = await supabase
      .from("meeting")
      .insert({
        uuid: meetingUuid,
        mentor_uuid: mentorObject.uuid,
        mentee_uuid: menteeObject.uuid,
        scheduled_time: new Date().toISOString(),
        duration: duration,
        status: "pending",
        // TODO: Need a better way to store the auth tokens
        mentor_auth_token: mentorAuthToken,
        mentee_auth_token: menteeAuthToken,
      })
      .select()
      .single();

    if (error) {
      console.error("Error creating meeting in Supabase:", error);
      throw error;
    }

    console.log("Meeting created successfully:", data);
    return data;
  } catch (error) {
    console.error("Error in createMeeting:", error);
    if (error instanceof Error) {
      console.error("Error details:", {
        message: error.message,
        stack: error.stack,
        name: error.name,
      });
    }
    throw error;
  }
}
